import queryString, { ParsedQuery } from 'query-string'
import { history } from '../connected-router/middleware'

export const getCurrentRequestParams = <
  Params extends { [K in keyof Params]?: string | null | Array<string | null> } = ParsedQuery,
>(): Params => {
  return queryString.parse(history.location.search) as Params
}
